/* Utility Function - Open and accordions */

/* Trigger Class = "accordion" */
/* Content must be next direct sibling, with the class "accordion__content" */
var accordion = document.getElementsByClassName("accordion");

for (i = 0; i < accordion.length; i++) {
  accordion[i].addEventListener("click", function() {
    var content = this.nextElementSibling;
    this.classList.toggle("open");
    content.classList.toggle("open");

    if (content.style.maxHeight){
      content.style.maxHeight = content.scrollHeight + "px";
      this.dataset.accordionicon = "+"
      setTimeout(() => {
      content.style.maxHeight = null;
      }, 1);
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
      this.dataset.accordionicon = "-"
      setTimeout(() => {
        content.style.maxHeight = "none";
      }, 200);
    } 
  });
}

/* Utility Function - Freeze Body */
freezeBodyToggle = (freezeBody) => {
  body = document.querySelector('body');

  if (freezeBody == false) {
    body.classList.remove('freezeBody');
  } else if (freezeBody == true) {
    body.classList.add('freezeBody');
  }
}

/* Handle auto-playing videos after page has loaded. */
window.addEventListener('load', function () {
  document.querySelectorAll('video').forEach((video) => {
    video.play();
  })
})

function initAjaxinate() {
  var endlessScroll = new Ajaxinate({offset: 200, loadingText: 'Loading Products', method: 'click'});
}